import { useSelector } from 'react-redux';
import { getAllUnreadNotifications } from 'js/reducers/selectors';
import { pick } from 'lodash';
import * as notificationsTypes from 'js/constants/notificationsTypes';
import { Notification } from 'new/entities/Notification';
import { createSelector } from 'reselect';

type Options = {
  onlyUnread?: boolean;
  type?: string;
};

function getEntities(state) {
  return state.entities;
}

function getNotifications(state) {
  return state.notifications;
}

export function useNotifications(options?: Options) {
  const memoSelector = createSelector(getEntities, getNotifications, (entities, notifications) => ({
    entities,
    notifications,
  }));
  const { entities, notifications } = useSelector(memoSelector);
  if (options?.onlyUnread) {
    const { notificationIds, notifications, loaded, unreadCounter } =
      useSelector(getAllUnreadNotifications);
    const items = notificationIds.map((id: number) => notifications[id]) as Notification[];
    return {
      unreadCounter,
      loaded,
      notifications: items,
    };
  }

  const {
    page,
    currentPage,
    ids,
    totalPages,
    showSize,
    lastUpdated,
    totalItemsCount: totalItems,
  } = notifications[options?.type || notificationsTypes.ALL];
  const items = pick(entities.notifications, ids) as Notification[];
  return {
    notifications: ids.map((id) => items[id]),
    meta: { page, currentPage, totalItems, totalPages, showSize, lastUpdated },
  };
}
